module.exports = __webpack_public_path__ + "static/media/66.9442b859.jpg";